import { coverFeatures } from "@/mocks/home";

const stats = [
  { value: "128", unit: "条", label: "今日更新" },
  { value: "42", unit: "个", label: "活跃话题" },
  { value: "6", unit: "起", label: "进行中事件" },
  { value: "18", unit: "张", label: "现场图集" },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full h-[620px] md:h-[780px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20editorial%20magazine%20cover%20collage%20of%20overlapping%20torn%20newspaper%20clippings%20and%20blurred%20anonymous%20crowd%20silhouettes%2C%20warm%20cream%20paper%20texture%2C%20bold%20crimson%20red%20ink%20splashes%2C%20dramatic%20chiaroscuro%20lighting%2C%20conceptual%20art%2C%20grainy%20print%20texture%2C%20high%20contrast%2C%20no%20readable%20text&width=1600&height=1000&seq=heiliaowang-hero-01&orientation=landscape"
        alt="黑料网吃瓜 封面主视觉 - 现场实拍与事件汇总"
        title="黑料网吃瓜 封面主视觉"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/85"></div>

      <div className="relative z-10 h-full w-full px-4 md:px-6 pt-24 md:pt-28 pb-10 md:pb-14 flex flex-col">
        <div className="w-full max-w-6xl mx-auto flex-1 flex flex-col justify-end">
          <div className="flex items-center gap-3 mb-5 reveal">
            <span className="h-px w-10 bg-primary-400"></span>
            <span className="text-xs md:text-sm tracking-[0.3em] text-primary-200 font-medium">封面故事 · COVER STORY</span>
          </div>

          <h1 className="font-heading font-black text-background-50 text-4xl md:text-6xl lg:text-7xl leading-[1.05] mb-4 reveal">
            黑料网吃瓜
          </h1>
          <p className="font-heading text-background-100 text-lg md:text-2xl leading-snug max-w-3xl mb-8 md:mb-10 reveal">
            今日热瓜现场直击，把事件的来龙去脉一次看全
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-px md:bg-background-50/15 rounded-lg overflow-hidden w-full mb-8 md:mb-10">
            {coverFeatures.map((f, i) => (
              <a
                key={f.title}
                href="#covers"
                className="group bg-foreground-950/45 backdrop-blur-sm md:bg-transparent md:backdrop-blur-none p-4 md:p-5 cursor-pointer hover:bg-foreground-950/65 transition-colors"
              >
                <span className="font-heading text-primary-300 text-sm tabular-nums">0{i + 1}</span>
                <p className="text-background-50 text-sm md:text-base leading-snug mt-2">{f.title}</p>
                <span className="inline-flex items-center gap-1 text-primary-300 text-xs mt-3 md:opacity-0 md:group-hover:opacity-100 transition-opacity">
                  查看详情
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
            ))}
          </div>

          <div className="flex flex-wrap items-center gap-x-8 gap-y-4 pt-6 border-t border-background-50/15 w-full">
            {stats.map((s) => (
              <div key={s.label} className="flex items-baseline gap-1.5">
                <span className="font-heading text-2xl md:text-3xl font-bold text-background-50 tabular-nums">{s.value}</span>
                <span className="text-xs text-background-100/70">{s.unit}</span>
                <span className="text-xs md:text-sm text-background-100/70 ml-1">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}